import { TableHead, TableHeader, TableRow } from "@/components/ui/table/table";

export const TableTHeader = () => {
	return (
		<TableHeader className="relative top-0 z-50 bg-bg-layer-400">
			<TableRow className="hover:bg-transparent">
				<TableHead justifyStyle="center" className="font-semibold">
					宿泊者名
				</TableHead>
				<TableHead justifyStyle="center" className="min-w-36 font-semibold">
					ホテル名
				</TableHead>
				<TableHead justifyStyle="center" className="font-semibold">
					メールアドレス
				</TableHead>
				<TableHead justifyStyle="center" className="min-w-48 font-semibold">
					施設メモ
				</TableHead>
				<TableHead justifyStyle="center" className="font-semibold">
					予約番号
				</TableHead>
				<TableHead justifyStyle="center" className="min-w-36 text-center font-semibold">
					チェックイン
					<br />
					チェックアウト
				</TableHead>
			</TableRow>
		</TableHeader>
	);
};
